import { render, staticRenderFns } from "./AdfoundNotificationManagementSettings.vue?vue&type=template&id=21599732"
import script from "./AdfoundNotificationManagementSettings.vue?vue&type=script&lang=js"
export * from "./AdfoundNotificationManagementSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports